import { Record } from "../../../fable_modules/fable-library-js.4.19.0/Types.js";
import { record_type, unit_type, lambda_type, string_type, option_type, list_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E } from "../../../fable_modules/Fable.React.9.4.0/./Fable.React.FunctionComponent.fs.js";
import { map, defaultArg, value as value_1 } from "../../../fable_modules/fable-library-js.4.19.0/Option.js";
import { int32ToString } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import * as react from "react";
import { Item_Option, Item_a, content, menu, trigger, Option, dropdown } from "../../../fable_modules/Fulma.3.0.0/Components/Dropdown.fs.js";
import { map as map_1, singleton, empty, ofArray } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { Option as Option_1, button } from "../../../fable_modules/Fulma.3.0.0/Elements/Button.fs.js";
import { Prop, DOMAttr } from "../../../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { Option as Option_2, icon as icon_1 } from "../../../fable_modules/Fulma.3.0.0/Elements/Icon.fs.js";
import { Size_ISize } from "../../../fable_modules/Fulma.3.0.0/Common.fs.js";
import { linkicon } from "../../../../Bfs.Web.Portale/ViewParts.fs.js";

export class DropdownProps$1 extends Record {
    constructor(Data, SelectedElement, ElementToString, ElementToKey, OnSelect) {
        super();
        this.Data = Data;
        this.SelectedElement = SelectedElement;
        this.ElementToString = ElementToString;
        this.ElementToKey = ElementToKey;
        this.OnSelect = OnSelect;
    }
}

export function DropdownProps$1_$reflection(gen0) {
    return record_type("Bfs.Web.Kundenportal.WebParts.User.Shared.Dropdown.DropdownProps`1", [gen0], DropdownProps$1, () => [["Data", list_type(gen0)], ["SelectedElement", option_type(gen0)], ["ElementToString", lambda_type(gen0, string_type)], ["ElementToKey", lambda_type(gen0, string_type)], ["OnSelect", lambda_type(gen0, unit_type)]]);
}

export function bfsDropdown() {
    return FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E((((value_1("C:\\BuildAgent\\work\\c238671ccc1e7da2\\BfsKundenportal\\src\\Bfs.Web.Kundenportal\\WebParts\\User\\Shared\\Dropdown.fs") + "#L") + int32ToString(value_1(25))) + ";") + "Bfs.Web.Kundenportal.WebParts.User.Shared.Dropdown.DropdownProps`1[\'T]", value_1("bfsDropdown"), (props) => {
        const isOpen = react.useState(false);
        const buttonRef = react.useRef(undefined);
        const selectedText = defaultArg(map(props.ElementToString, props.SelectedElement), "");
        const icon = (isOpen[0]) ? "fa-chevron-up" : "fa-chevron-down";
        return dropdown(ofArray([new Option(0, [isOpen[0]]), new Option(5, ["is-fullwidth"])]), ofArray([trigger(empty(), singleton(button(ofArray([new Option_1(18, [(_arg) => {
            isOpen[1](!(isOpen[0]));
            const input = value_1(buttonRef.current);
            input.focus();
        }]), new Option_1(17, [ofArray([new DOMAttr(8, [(_arg_1) => {
            isOpen[1](false);
        }]), new Prop(3, [buttonRef])])])]), ofArray([react.createElement("span", {}, selectedText), icon_1(singleton(new Option_2(0, [new Size_ISize(0, [])])), singleton(linkicon(`fas ${icon}`)))])))), menu(empty(), singleton(content(empty(), map_1((item) => {
            const label = props.ElementToString(item);
            return Item_a(ofArray([new Item_Option(0, [label === selectedText]), new Item_Option(1, [singleton(new DOMAttr(51, [(_arg_2) => {
                props.OnSelect(item);
            }]))])]), singleton(label));
        }, props.Data))))]));
    }, undefined, undefined, "Of");
}

//# sourceMappingURL=Dropdown.fs.js.map
